/* Pantheratec Kabelquerschnitt-Rechner v1.0 — 12/24 V DC Spannungsfall-Vorauswahl */
(function () {
  'use strict';
  const GAUGES=[0.5,0.75,1,1.5,2.5,4,6,10,16,25,35,50,70,95,120,150,185,240];
  const MATERIAL={copper:{rho:0.01786,alpha:0.00393,label:'Kupfer'},aluminium:{rho:0.02826,alpha:0.00403,label:'Aluminium'}};
  const integer=val=>Number.isFinite(Number(val))?Number(val):NaN;
  const n=v=>{if(typeof v==='string')v=v.trim().replace(',','.');return Number(v);};
  const valid=(v,min,max)=>Number.isFinite(v)&&v>=min&&v<=max;
  const fmt=(num,digits=1)=>Number(num).toLocaleString('de-DE',{minimumFractionDigits:digits,maximumFractionDigits:digits});
  const gaugeString=val=>Number(val).toLocaleString('de-DE',{maximumFractionDigits:2});
  const encodeNumber=val=>Number(val).toLocaleString('de-DE',{maximumFractionDigits:2});

  // Models a DC circuit with two equal-length conductors (positive + negative),
  // idealized resistivity at conductor temperature. No ampacity/circuit protection proof.
  function calculate(raw) {
    const voltage=n(raw.voltage),length=n(raw.length),temp=n(raw.temperature);
    const material=MATERIAL[raw.material];
    const target=n(raw.drop_target);
    const mode=raw.load_mode||'power';
    if(![12,24].includes(voltage))throw Error('Bitte ein 12-V- oder 24-V-Bordnetz auswählen.');
    if(!valid(length,0.1,100))throw Error('Bitte eine einfache Leitungslänge zwischen 0,1 und 100 m angeben.');
    if(!material)throw Error('Bitte ein gültiges Leitermaterial auswählen.');
    if(![20,40,60,70,90].includes(temp))throw Error('Bitte eine gültige Leitertemperatur auswählen.');
    if(![1,2,3,5].includes(target))throw Error('Bitte ein gültiges Spannungsabfall-Planungsziel auswählen.');
    let amps=0,power=0,eff=1;
    if(mode==='current'){
      amps=n(raw.current);
      if(!valid(amps,0.1,400))throw Error('Bitte einen Betriebsstrom zwischen 0,1 und 400 A angeben.');
      power=amps*voltage;
    }else if(mode==='inverter'){
      power=n(raw.inverter_power);
      eff=n(raw.efficiency);
      if(!valid(power,1,6000))throw Error('Bitte eine Wechselrichter-Ausgangsleistung zwischen 1 und 6.000 W angeben.');
      if(!valid(eff,0.75,1))throw Error('Bitte einen realistischen Wirkungsgrad auswählen.');
      amps=power/(voltage*eff);
    }else if(mode==='power'){
      power=n(raw.power);
      if(!valid(power,1,8000))throw Error('Bitte eine Gleichstrom-Leistungsaufnahme zwischen 1 und 8.000 W angeben.');
      amps=power/voltage;
    }else throw Error('Bitte die Art der Leistungsangabe auswählen.');
    if(!valid(amps,0.01,400))throw Error('Die angenommene Stromaufnahme liegt außerhalb des Bereichs von 0,1 bis 400 A. Bitte fachkundig planen.');
    const resistivity=material.rho*(1+material.alpha*(temp-20));
    const loopLength=2*length;
    const allowableDrop=voltage*target/100;
    const minimumSection=loopLength*amps*resistivity/allowableDrop;
    const recommended=GAUGES.find(g=>g+1e-9>=minimumSection)||null;
    const deltaV=recommended?loopLength*amps*resistivity/recommended:null;
    const percent=recommended?deltaV/voltage*100:null;
    const loss=recommended?deltaV*amps:null;
    const candidateVoltage=recommended?voltage-deltaV:null;
    const existingGauge=raw.existing_gauge? n(raw.existing_gauge):null;
    if(existingGauge!==null&&!GAUGES.includes(existingGauge))throw Error('Bitte einen gültigen vorhandenen Querschnitt auswählen.');
    const existing=existingGauge?{
      gauge:existingGauge,
      deltaV:loopLength*amps*resistivity/existingGauge,
      percent:loopLength*amps*resistivity/existingGauge/voltage*100,
      loss:loopLength*amps*resistivity/existingGauge*amps
    }:null;
    function optionalAmp(v,label){
      if(v===''||v===undefined||v===null)return null;
      const amount=n(v);
      if(!valid(amount,0.1,600))throw Error('Bitte bei „'+label+'“ einen gültigen Wert von 0,1 bis 600 A eintragen oder das Feld leeren.');
      return amount;
    }
    const fuse=optionalAmp(raw.fuse,'Sicherung');
    const ampacity=optionalAmp(raw.ampacity,'zulässiger Dauerstrom');
    const installation=raw.installation||'open';
    if(!['open','duct','insulated','bundled','hot'].includes(installation))throw Error('Bitte eine gültige Verlegeumgebung auswählen.');
    const idx=recommended?GAUGES.indexOf(recommended):GAUGES.length-1;
    const comparisons=GAUGES.slice(Math.max(0,idx-3),Math.min(GAUGES.length,idx+3)).map(g=>{
      const v=loopLength*amps*resistivity/g;
      return {gauge:g,deltaV:v,percent:v/voltage*100,loss:v*amps,within:v<=allowableDrop+1e-9,recommended:g===recommended};
    });
    return {voltage,material:raw.material,materialLabel:material.label,length,loopLength,temp,target,mode,eff,
      amps,power,installation,fuse,ampacity,minimumSection,recommended,resistivity,
      deltaV,percent,loss,candidateVoltage,existing,comparisons,
      overMax:recommended===null};
  }
  // Used by local tests, not required for browser operation.
  if(typeof module!=='undefined'&&module.exports)module.exports={calculate,GAUGES};
  if(typeof document==='undefined')return;

  function elem(tag,klass,text){const e=document.createElement(tag);if(klass)e.className=klass;if(text!==undefined)e.textContent=String(text);return e;}
  function clear(e){if(e)e.replaceChildren();}
  function addText(parent,tag,klass,text){const e=elem(tag,klass,text);parent.appendChild(e);return e;}
  function safeUrl(value){try{const u=new URL(String(value),window.location.origin);if(u.origin!==window.location.origin)return null;if(!['http:','https:'].includes(u.protocol))return null;return u.href;}catch(_){return null;}}
  function imageUrl(value){try{const u=new URL(String(value),window.location.origin);if(!['http:','https:'].includes(u.protocol))return null;return u.href;}catch(_){return null;}}
  function textCurrency(cents,code){try{return new Intl.NumberFormat('de-DE',{style:'currency',currency:code||'EUR'}).format(cents/100);}catch(_){return fmt(cents/100,2)+' €';}}

  function init(root){
    if(root.dataset.ptccReady==='1')return;
    root.dataset.ptccReady='1';
    const form=root.querySelector('[data-ptcc-form]');
    if(!form)return;
    const steps=[...root.querySelectorAll('[data-ptcc-step]')],tabs=[...root.querySelectorAll('[data-ptcc-tab]')];
    const btnPrev=root.querySelector('[data-ptcc-prev]'),btnNext=root.querySelector('[data-ptcc-next]');
    const err=root.querySelector('[data-ptcc-error]');
    let step=0,stored=null,requestSeq=0;
    let verified=[];
    try{verified=JSON.parse(root.querySelector('[data-ptcc-products-json]')?.textContent||'[]');if(!Array.isArray(verified))verified=[];}catch(_){verified=[];}
    const field=name=>form.elements.namedItem(name);
    const val=name=>field(name)?.value??'';
    const showMessage=text=>{err.textContent=text;err.hidden=!text;};
    function updateMode(){
      const mode=val('load_mode');
      root.querySelector('[data-ptcc-power]').hidden=mode!=='power';
      root.querySelector('[data-ptcc-current]').hidden=mode!=='current';
      root.querySelector('[data-ptcc-inverter]').hidden=mode!=='inverter';
      root.querySelector('[data-ptcc-efficiency]').hidden=mode!=='inverter';
    }
    function getInput(){
      return {voltage:val('voltage'),length:val('length'),material:val('material'),temperature:val('temperature'),drop_target:val('drop_target'),
        load_mode:val('load_mode'),power:val('power'),current:val('current'),inverter_power:val('inverter_power'),efficiency:val('efficiency'),
        existing_gauge:val('existing_gauge'),fuse:val('fuse'),ampacity:val('ampacity'),installation:val('installation')};
    }
    function setStep(next){
      step=Math.min(3,Math.max(0,next));showMessage('');
      steps.forEach((p,i)=>{p.hidden=i!==step;p.setAttribute('aria-hidden',String(i!==step));});
      tabs.forEach((t,i)=>{t.classList.toggle('is-active',i===step);t.classList.toggle('is-done',i<step);if(i===step)t.setAttribute('aria-current','step');else t.removeAttribute('aria-current');});
      const progress=root.querySelector('[data-ptcc-progress]');
      progress.setAttribute('aria-valuenow',String(step+1));progress.querySelector('span').style.width=((step+1)*25)+'%';
      root.querySelector('[data-ptcc-counter]').textContent='Schritt '+(step+1)+' von 4';
      btnPrev.hidden=step===0;btnNext.hidden=step===3;
      if(step<3)btnNext.textContent=['Weiter zur Leitung →','Weiter zum Einbau →','Ergebnis berechnen →'][step];
      // Retain viewport if current wizard is partially scrolled away; avoid forcing page jumps on mobile.
      const rect=root.querySelector('.ptcc__wizard').getBoundingClientRect();
      if(rect.top<-90)root.querySelector('.ptcc__wizard').scrollIntoView({behavior:'auto',block:'start'});
    }
    const names=['power','current','inverter_power'];
    root.querySelector('[data-ptcc-preset]')?.addEventListener('change',e=>{
      const v=e.target.value;
      const presets={led:{mode:'power',power:24},fridge:{mode:'power',power:72},pump:{mode:'power',power:120},heater:{mode:'power',power:120},inverter:{mode:'inverter',power:1000}};
      if(presets[v]){
        const x=presets[v];form.querySelector('[name="load_mode"][value="'+x.mode+'"]').checked=true;
        field(x.mode==='inverter'?'inverter_power':'power').value=x.power;updateMode();
      }
    });
    root.querySelectorAll('[name="load_mode"]').forEach(r=>r.addEventListener('change',updateMode));
    btnPrev?.addEventListener('click',()=>setStep(step-1));
    btnNext?.addEventListener('click',()=>{
      try{
        // Validate all inputs already present, before proceeding.
        const r=calculate(getInput());showMessage('');
        if(step===2){stored=r;renderResult(r);setStep(3);}else setStep(step+1);
      }catch(e){showMessage(e.message||'Bitte überprüfe deine Angaben.');}
    });
    form.addEventListener('submit',e=>e.preventDefault());
    root.querySelector('[data-ptcc-print]')?.addEventListener('click',()=>window.print());
    root.querySelector('[data-ptcc-reset]')?.addEventListener('click',()=>{requestSeq++;form.reset();field('preset').value='custom';updateMode();setStep(0);stored=null;});
    root.querySelector('[data-ptcc-copy]')?.addEventListener('click',async()=>{
      if(!stored)return;
      const r=stored;
      const txt='Pantheratec Kabelquerschnitt-Rechner (unverbindlich)\n'
        +'Bordnetz: '+r.voltage+' V DC | Leiter: '+r.materialLabel+' | '+fmt(r.length)+' m einfach\n'
        +'Angenommener Strom: '+fmt(r.amps,2)+' A | Leitungstemperatur: '+fmt(r.temp,0)+' °C\n'
        +'Planungsziel: '+fmt(r.target,0)+' % Spannungsabfall\n'
        +'Rechnerisches A_min: '+fmt(r.minimumSection,2)+' mm²\n'
        +'Querschnitts-Vorauswahl: '+(r.recommended?gaugeString(r.recommended)+' mm²':'über 240 mm²')+'\n'
        +(r.recommended?'Spannungsabfall: '+fmt(r.deltaV,3)+' V / '+fmt(r.percent,2)+' %\n':'')
        +'Kein Nachweis von Strombelastbarkeit, Sicherung, Kurzschlussschutz oder Normkonformität. Vor der Installation fachkundig prüfen.\n'+window.location.href.split('?')[0];
      const feedback=root.querySelector('[data-ptcc-feedback]');
      try{await navigator.clipboard.writeText(txt);feedback.textContent='Berechnung kopiert.';}catch(_){feedback.textContent='Automatisches Kopieren nicht möglich. Bitte Druckfunktion verwenden.';}
    });
    function resultText(name,text){const n=root.querySelector('[data-ptcc-result="'+name+'"]');if(n)n.textContent=text;}
    function notify(kind,text){const box=root.querySelector('[data-ptcc-notices]');box.appendChild(elem('div','ptcc__status'+(kind?' ptcc__status--'+kind:''),text));}
    function calcRow(wrapper,key,value){const row=elem('div','ptcc__calc-row');addText(row,'span','',key);addText(row,'strong','',value);wrapper.appendChild(row);}
    function renderResult(r){
      const tags=root.querySelector('[data-ptcc-tags]');clear(tags);
      [r.voltage+' V DC',r.materialLabel,fmt(r.length)+' m einfache Strecke',fmt(r.temp,0)+' °C Leiter',fmt(r.target,0)+' % Spannungsfallziel'].forEach(t=>addText(tags,'span','',t));
      resultText('gauge',r.recommended?gaugeString(r.recommended)+' mm²':'> 240 mm²');
      resultText('amps',fmt(r.amps,2)+' A');
      resultText('drop',r.recommended?fmt(r.percent,2)+' %':'–');
      resultText('dropv',r.recommended?fmt(r.deltaV,3)+' V bei '+gaugeString(r.recommended)+' mm²':'Kein gelisteter Standardquerschnitt ausreichend');
      resultText('loss',r.recommended?fmt(r.loss,1)+' W':'–');
      const notices=root.querySelector('[data-ptcc-notices]');clear(notices);
      notify('warn','Dies ist ausschließlich eine Spannungsfall-Vorauswahl. Zulässige Strombelastbarkeit, Isolierung, Leitungstyp, mechanischer Schutz und Überstrom-/Kurzschlussschutz sind damit nicht nachgewiesen.');
      if(r.overMax)notify('error','Der rechnerische Mindestquerschnitt liegt über 240 mm². Bitte den Stromkreis fachkundig neu dimensionieren; keine automatische Kabelwahl.');
      if(r.mode==='inverter')notify('warn','Bei Wechselrichtern sind insbesondere Batterie-Unterspannung, Spitzen-/Anlaufströme und Herstellerangaben zu Kabeln/Sicherungen separat zu berücksichtigen. Die 230-V-Seite ist nicht Teil dieser Berechnung.');
      if(r.material==='aluminium')notify('warn','Aluminiumleiter benötigen speziell geeignete Verbindungen und eine für den Fahrzeug-Einsatz freigegebene Konstruktion. Nicht einfach an Kupferklemmen anschließen.');
      if(r.temp>=70)notify('warn','Die angenommene Leitertemperatur ist hoch. Prüfe, ob Isolierung, Klemmen und die reale Installation dafür zulässig sind.');
      if(r.amps>100)notify('warn','Hohe Gleichströme erfordern besondere Prüfung von Steckverbindern, Anschlüssen, Batterieanschluss und Kurzschlussschutz.');
      const installNames={open:'frei / gut belüftet',duct:'im Rohr oder Kabelkanal',insulated:'an / in Wärmedämmung',bundled:'gebündelt mit anderen Leitungen',hot:'im warmen Bereich / Motorraum'};
      if(r.installation!=='open')notify('warn','Verlegeumgebung: '+installNames[r.installation]+'. Diese kann die thermische Strombelastbarkeit reduzieren. Ein eigener Norm-/Herstellernachweis ist erforderlich.');
      if(r.existing){
        if(r.existing.percent>r.target+1e-7)notify('warn','Der vorhandene Querschnitt von '+gaugeString(r.existing.gauge)+' mm² überschreitet dein Spannungsfallziel: '+fmt(r.existing.percent,2)+' % statt '+fmt(r.target,0)+' %.');
        else notify('','Dein vorhandener Querschnitt von '+gaugeString(r.existing.gauge)+' mm² erfüllt im Modell das gewählte Spannungsfallziel ('+fmt(r.existing.percent,2)+' %). Das sagt nichts über seine Strombelastbarkeit aus.');
      }
      if(r.fuse!==null){
        if(r.fuse<r.amps)notify('warn','Eingetragene Sicherung: '+fmt(r.fuse,1)+' A, angenommener Betriebsstrom: '+fmt(r.amps,1)+' A. Die Nennwerte sind zu prüfen, insbesondere unter Berücksichtigung der Auslösecharakteristik.');
        if(r.ampacity===null)notify('warn','Für die Sicherungsprüfung fehlt die nach Herstellervorgaben und Verlegebedingungen ermittelte zulässige Dauerstrombelastbarkeit der Leitung.');
      }
      if(r.ampacity!==null){
        if(r.ampacity<r.amps)notify('error','Die von dir angegebene Dauerstrombelastbarkeit ('+fmt(r.ampacity,1)+' A) liegt unter dem Betriebsstrom ('+fmt(r.amps,1)+' A). Diese Leitungsausführung ist nicht ausreichend.');
        if(r.fuse!==null&&r.fuse>r.ampacity)notify('error','Die Sicherung ('+fmt(r.fuse,1)+' A) liegt über der angegebenen Dauerstrombelastbarkeit ('+fmt(r.ampacity,1)+' A). Dimensionierung fachkundig prüfen.');
        if(r.fuse!==null&&r.fuse<=r.ampacity&&r.fuse>=r.amps)notify('','Sicherungs-Nennwert und eingegebener Dauerstrom sind rein zahlenmäßig plausibel. Abschaltcharakteristik, Kurzschlussbedingungen und Normkonformität sind nicht geprüft.');
      }
      const calc=root.querySelector('[data-ptcc-calculation]');clear(calc);
      const list=elem('div','ptcc__calc-list');calc.appendChild(list);
      calcRow(list,'Gesamter Leiterweg (Plus + Minus)',fmt(r.loopLength,2)+' m');
      calcRow(list,'Angenommener spezifischer Widerstand bei '+fmt(r.temp,0)+' °C',fmt(r.resistivity,5)+' Ω·mm²/m');
      calcRow(list,'Maximaler Spannungsabfall nach deinem Ziel',fmt(r.voltage*r.target/100,3)+' V');
      calcRow(list,'Rechnerischer Mindestquerschnitt Aₘᵢₙ',fmt(r.minimumSection,3)+' mm²');
      if(r.recommended){
        calcRow(list,'Rechnerische Spannung am Verbraucher',fmt(r.candidateVoltage,2)+' V (ohne Kontaktverluste)');
        calcRow(list,'Ohmsche Verlustleistung der Leiter',fmt(r.loss,2)+' W');
      }
      addText(calc,'p','ptcc__formula','Formel: ΔU = (2 × einfache Länge × Betriebsstrom × ρ bei Leitertemperatur) ÷ Querschnitt. Das Modell setzt zwei gleich lange Leiter voraus, ohne Kontaktwiderstände oder stromabhängige Zusatzverluste.');
      const compare=root.querySelector('[data-ptcc-compare]');clear(compare);
      r.comparisons.forEach(c=>{
        const tr=elem('tr',c.recommended?'is-highlight':'');
        [gaugeString(c.gauge)+' mm²',fmt(c.percent,2)+' %',fmt(c.deltaV,3)+' V',fmt(c.loss,1)+' W'].forEach(value=>addText(tr,'td','',value));
        addText(tr,'td',c.within?'ptcc__tag-ok':'ptcc__tag-no',c.within?'Ziel erfüllt':'Über Ziel');
        compare.appendChild(tr);
      });
      requestSeq++;
      renderProducts(r,requestSeq);
    }

    function createProductCard(product,mode,r){
      const card=elem('article','ptcc__product');
      const imgBox=elem('div','ptcc__product-image');
      const src=imageUrl(product.image);
      if(src){const img=elem('img');img.src=src;img.alt='';img.loading='lazy';imgBox.appendChild(img);}else addText(imgBox,'span','','Kein Produktbild');
      card.appendChild(imgBox);
      const body=elem('div','ptcc__product-content');card.appendChild(body);
      const own=Boolean(product.own);
      addText(body,'span','ptcc__product-badge'+(own?' ptcc__product-badge--own':(mode==='candidate'?' ptcc__product-badge--candidate':'')),
        mode==='candidate'?'Produktdaten prüfen':(own?'Pantheratec · lieferbar':'Hinterlegtes Kabel · lieferbar'));
      addText(body,'span','ptcc__product-title',product.title||'Kabelartikel');
      if(mode==='verified'){
        const cores=Number(product.cores)===2?2:1;
        addText(body,'span','ptcc__product-spec',gaugeString(product.sectionMm2)+' mm² · '+(product.material==='copper'?'Kupfer':'Aluminium')+' · '+(cores===1?'einadrig':'zweiadrig'));
        const needed=r.length*(cores===1?2:1);
        const pack=Number(product.lengthPerUnit)||0;
        const text=pack>0?'Leitungsbedarf ca. '+fmt(needed,1)+' m · rechnerisch '+Math.ceil(needed/pack)+' Verkaufseinheit(en), falls '+gaugeString(pack)+' m je Einheit':'Leitungsbedarf ca. '+fmt(needed,1)+' m · tatsächliche Verkaufseinheit prüfen';
        addText(body,'span','ptcc__product-spec',text);
        if(Number(product.ampacity)>0)addText(body,'span','ptcc__product-spec','Hinterlegter Dauerstrom: '+fmt(product.ampacity,1)+' A (Hersteller-/Verlegeprüfung erforderlich)');
        else addText(body,'span','ptcc__product-spec','Strombelastbarkeit: separat prüfen');
        if(product.note)addText(body,'span','ptcc__product-note',product.note);
        if(Number.isFinite(Number(product.priceCents)))addText(body,'strong','ptcc__product-price',textCurrency(Number(product.priceCents),root.dataset.currency));
      }else{
        addText(body,'span','ptcc__product-spec','Suchtreffer – Querschnitt, Fahrzeugtauglichkeit, Preis und Verfügbarkeit auf der Produktseite prüfen');
      }
      const href=safeUrl(product.url);
      if(href){const link=addText(body,'a','ptcc__product-link',mode==='verified'?'Produkt ansehen →':'Daten und Verfügbarkeit prüfen →');link.href=href;}
      return card;
    }
    function heading(wrapper,title){return addText(wrapper,'h5','',title);}
    function verifiedMatches(r){
      if(!r.recommended)return[];
      return verified.filter(p=>{
        if(p.stock!==true || p.material!==r.material)return false;
        if(!(Number(p.sectionMm2)>=r.recommended))return false;
        if(Number(p.ampacity)>0&&Number(p.ampacity)<r.amps)return false;
        return Boolean(safeUrl(p.url));
      }).sort((a,b)=>Number(b.own)-Number(a.own)||Number(a.sectionMm2)-Number(b.sectionMm2));
    }
    async function fetchCandidates(r){
      if(!r.recommended||root.dataset.suggestions!=='true')return[];
      const base=(root.dataset.rootUrl||'/').replace(/\/?$/, '/');
      const searchTerms=['fahrzeugleitung '+gaugeString(r.recommended).replace(',','.')+'mm2','kabel '+gaugeString(r.recommended).replace(',','.')+'mm2'];
      const matches=[];
      for(const q of searchTerms){
        try{
          const url=new URL('search/suggest.json',new URL(base,window.location.origin));
          url.searchParams.set('q',q);
          url.searchParams.set('resources[type]','product');
          url.searchParams.set('resources[limit]','10');
          url.searchParams.set('resources[options][unavailable_products]','hide');
          const response=await fetch(url.toString(),{credentials:'same-origin',headers:{Accept:'application/json'}});
          if(!response.ok)continue;
          const data=await response.json();
          const items=data?.resources?.results?.products;
          if(Array.isArray(items))matches.push(...items);
        }catch(_){/* Search is optional. Verified product recommendations remain visible. */}
      }
      const seen=new Set();
      const target=String(r.recommended).replace('.','[.,]');
      const rx=new RegExp('(^|[^0-9])'+target+'\\s*mm\\s*(?:2|²)?($|[^0-9])','i');
      return matches.filter(p=>{
        if(p.available===false)return false;
        const key=p.id||p.url;
        if(!key||seen.has(key))return false;
        if(!/kabel|leitung|fahrzeuglitze|fahrzeugleitung/i.test(String(p.title||'')))return false;
        if(!rx.test(String(p.title||'')))return false;
        if(!safeUrl(p.url))return false;
        seen.add(key);return true;
      }).slice(0,6).map(p=>({title:p.title,url:p.url,image:p.featured_image?.url||p.image||null,own:false}));
    }
    function renderProducts(r,sequence){
      const host=root.querySelector('[data-ptcc-recommendations]');clear(host);
      if(!r.recommended){addText(host,'p','ptcc__product-empty','Für diese Eingabe ist keine sinnvolle automatische Produktauswahl möglich. Bitte die elektrische Anlage fachkundig planen.');return;}
      const found=verifiedMatches(r);
      if(found.length){
        const group=elem('div','ptcc__products-group');host.appendChild(group);
        heading(group,'Hinterlegte, verfügbare Kabel – Pantheratec zuerst');
        const grid=elem('div','ptcc__products-grid');group.appendChild(grid);
        found.slice(0,6).forEach(p=>grid.appendChild(createProductCard(p,'verified',r)));
      }else addText(host,'p','ptcc__product-empty','Derzeit ist kein mit diesem Querschnitt, Material und gemeldeter Verfügbarkeit hinterlegtes Kabel vorhanden. Weitere Suchtreffer können unten erscheinen.');
      const fallback=elem('div','ptcc__products-group');host.appendChild(fallback);
      heading(fallback,'Weitere Kabel aus unserem Sortiment');
      const info=addText(fallback,'p','ptcc__product-note','Suche nach Kabelartikeln. Diese Treffer sind keine technische oder sicherheitsbezogene Empfehlung.');
      const pending=addText(fallback,'p','ptcc__product-note','Suche nach weiteren Kabelprodukten …');
      fetchCandidates(r).then(items=>{
        if(sequence!==requestSeq)return;
        pending.remove();
        if(items.length){
          const grid=elem('div','ptcc__products-grid');fallback.appendChild(grid);
          items.forEach(p=>grid.appendChild(createProductCard(p,'candidate',r)));
        }else addText(fallback,'p','ptcc__product-note','Keine zusätzlichen Kandidaten gefunden. Über die Shopsuche kannst du weitere Größen und Kabelarten vergleichen.');
        const q=encodeURIComponent('Fahrzeugleitung '+String(r.recommended).replace('.','.')+' mm2');
        const a=addText(fallback,'a','ptcc__product-link','Alle entsprechenden Kabel suchen →');
        a.href=safeUrl((root.dataset.rootUrl||'/').replace(/\/?$/, '/')+'search?q='+q+'&type=product')||'/search';
      }).catch(()=>{if(sequence===requestSeq)pending.textContent='Produktsuche vorübergehend nicht verfügbar.';});
    }
    updateMode();setStep(0);
  }
  function initAll(scope=document){
    if(scope.matches&&scope.matches('[data-ptcc]'))init(scope);
    scope.querySelectorAll?.('[data-ptcc]').forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll());else initAll();
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();
